import { GET_ALL_USER_LEVEL } from '../../types'

const INITIAL_STATE = {
  getAllUserLevel: [],
}

const userLevelReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_USER_LEVEL:
      return {
        ...state,
        getAllUserLevel: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default userLevelReducer
